import { useMemo } from 'react';
export const useHasBenefitTag = (benefitTags, expectedTag) => {
    return useMemo(() => {
        if (!benefitTags)
            return false;
        return !!(benefitTags === null || benefitTags === void 0 ? void 0 : benefitTags.some(({ tagName }) => {
            return tagName === expectedTag;
        }));
    }, [benefitTags, expectedTag]);
};
